import { render, staticRenderFns } from "./InsertImageDialog.vue?vue&type=template&id=ce248270&scoped=true&"
import script from "./InsertImageDialog.vue?vue&type=script&lang=js&"
export * from "./InsertImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./InsertImageDialog.vue?vue&type=style&index=0&id=ce248270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce248270",
  null
  
)

export default component.exports